<template>
    <v-app>
      <v-main>
          <router-view />
      </v-main>
    </v-app>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {
      dialogSalida: false,
      pushToken: null,
    };
  },
  components: {
  },
  async beforeCreate(){
    
  },
  async created(){

  },
  async mounted() { 
    await this.$store.dispatch("LoginStore/doLoginAPI");
  },

  methods: {

  },
}
</script>

<style >

.v-dialog{
  margin: 0px !important;
  box-shadow: none !important;
}

@viewport {
  viewport-fit: cover;
}
#app {
  font-family: 'Nunito', sans-serif;
  background-color: white !important;
}
.v-main {
  max-height: 90% !important;
  background-color: white !important;
}
.v-main__wrap {
  background-color: white !important;
}


.v-btn:before {
  opacity: 0 !important;
}

.v-ripple__container {
  opacity: 0 !important;
}
.v-input--selection-controls__ripple {
  opacity: 0 !important;
}

/* Controles Mapa */

button.gm-control-active.gm-fullscreen-control {
    display: none;
}

  @media only screen and (max-width: 340px)  {
  .gmnoprint.gm-bundled-control.gm-bundled-control-on-bottom {
    position: absolute;
    bottom: 17.5rem !important;
  }
}

/* Iconos*/

i.v-icon.notranslate.fa.fa-solid.fa-magnifying-glass.theme--light {
  color: #0072B9;
  font-size: 20px;
}
i.v-icon.notranslate.fa.fa-solid.fa-caret-down.theme--light {
  color: #0072B9;
}
i.v-icon.notranslate.fa.fa-solid.fa-angle-right.theme--dark , i.v-icon.notranslate.fa.fa-solid.fa-angle-left.theme--dark {
  font-size: 24px !important;
}

label.v-label.theme--light {
    font-weight: 700;
}
.v-chip .v-chip__content {
  font-weight: 700;
}
</style>
